import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button,Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import ModalComponent from '../Layout/Modal';
import { getAllHome } from '../../actions/home';
import { addjobAction, updateJobAction, jobListByComAction, jobStatusAction, jobEditDataAction } from '../../actions/job';
import { notification } from 'antd';
import JobEdit from './JobEdit';
import JobAdd from './JobAdd.js';
import loadingImage from "../loadingImageRc.gif";
import $ from "jquery";
let className = "";

class JobList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            count: 0, 
            currentPage: 1,
            sizePerPage: 10,
            requestServer: true,
            detailsModal: false,
            addJobModal: false,
            editModal: false,
            // popoverOpen: false,
            popoverOpen: {},
            jobDetails: {},
            editJobs: {},
            userData: JSON.parse(localStorage.getItem('userData'))

        };
        this.editDetails=this.editDetails.bind(this)
    }
 
    componentWillMount() {
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        //this.profile();
        this.props.jobListByComAction(reqObj);
    }

    jobListGet = (sizePerPage, page) => {
        let reqObj = {
            "limit": sizePerPage,
            "offset": (page - 1),
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        //this.profile();
        this.props.jobListByComAction(reqObj);
    }

    componentWillReceiveProps(nextProps) {
        switch (nextProps.responseType) {
            case "addJob":
                notification.success({
                    message: nextProps.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.setState({
                    requestServer:false,
                    addJobModal:false
                },(function(){
                    this.jobListGet(this.state.sizePerPage, this.state.page);
                }))

                break;
            case "jobProviderListing":
                this.setState({
                    requestServer: false,
                    list: nextProps.response.data && nextProps.response.data.data,
                    count: nextProps.response.data && nextProps.response.data.count,
                })
                break;
            case "jobStatus":
                let _this = this;
                notification.success({
                    message: nextProps.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.jobListGet(this.state.sizePerPage, this.state.page);
                break;
            case "updateJob":
                this.setState({
                    editJobs: {},
                    requestServer:false,
                    editModal: false
                })
                break;
            default:
            return true;
        }
    }

    viewJobs = (data) => {
        this.setState({
            jobDetails: data,
            detailsModal: !this.state.detailsModal
        })
    }

    editJobs = (data) => {
        this.props.jobEditDataAction(data)
        this.setState({
            editJobs: data,
            editModal: true
        })
    }

    viewDetails = () => {
        this.setState({
            jobDetails: {},
            detailsModal: !this.state.detailsModal
        })
    }

    editDetails = () => {
        this.setState({
            editModal: !this.state.editModal
        })
    }

    addJobsModal = () => {
        this.setState({
            addJobModal: !this.state.addJobModal
        })
    }

    sizePerPageListChange(sizePerPage) {
        this.setState({
            sizePerPage: sizePerPage
        })
        this.jobListGet(sizePerPage, this.state.currentPage);
    }

    chnageStatus = (data, type, value) => {
        let reqObj = {
            id: data._id
        }
        if (data.status === "active") {
            reqObj.status = "inactive"
        } else {
            reqObj.status = "active"
        }

        this.setState({
            statusChange: true
        })
        this.props.jobStatusAction(reqObj)
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            currentPage: page,
            sizePerPage: sizePerPage
        })
        this.jobListGet(sizePerPage, (page));
    }
    
    toggle = (id) => {
        let popStatus  = this.state.popoverOpen ;
        let keys = Object.keys(popStatus);
        if(keys && keys.length > 0){
            for (let y in keys){
                  popStatus[keys[y]] = false;
            }
        }
        if(id){
          popStatus[id] = popStatus[id] ? false:true;
        }
          this.setState({
              popoverOpen: popStatus
          })
    };

    copyCodeToClipboard = () => {
        const el = this.textArea1
        el.select()
        document.execCommand("copy")
        this.setState({copySuccess: true})
    }

    jobActionList(cell, row, rowIndex) {
        const {userData} = this.state;
        if (row && row.status) {

            return <div>
                <button className="buttons1" onClick={this.viewJobs.bind(this,row,"status")}>View</button>&nbsp;&nbsp;
                <button className="buttons1"onClick={this.editJobs.bind(this,row,"status")}>Edit</button>&nbsp;&nbsp;
                <button className="buttons1"onClick={this.chnageStatus.bind(this,row,"status")}>{row.status}</button>&nbsp;
                <button className="buttons1"  id={"Popover1"+row._id}>Share Link</button>
                
                <Popover placement="right-start" isOpen={this.state.popoverOpen[row._id] ?this.state.popoverOpen[row._id] :false} target={"Popover1"+row._id} toggle={()=>this.toggle(row._id)}>
                    <PopoverHeader>
                        <button type="button" onClick={()=>this.toggle()} className="closeBtn close color-yg" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <span className="shareLink">
                            <input ref={(textarea) => this.textArea1 = textarea} className="singup-control" value={process.env.REACT_APP_HOST+"/"+userData.userUrlLink+"/job/"+row.jobId} /> 
                            <button className="copybtn buttons1" onClick={() => this.copyCodeToClipboard()}><i class="fa fa-clone" aria-hidden="true"></i></button>
                        </span>
                    </PopoverHeader>
                </Popover>
      
            </div>
        } else {
            return <span>-</span>
        }
    }

    onGetProjectSEDate(cell, row, rowIndex) {
        if (row && row.createdAt) {
            return (this.props.auth.formatDate(row.createdAt))
        } else {
            return <span>-</span>
        }
    }



    render() {

        const { categoryOption, cityOption } = this.props;
        const { sizePerPage, list, count, requestServer, jobDetails, editJobs } = this.state;
        var options = {
            onPageChange: this.onPageChange.bind(this),
            page: this.state.currentPage,
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            sizePerPage: sizePerPage,
            paginationPosition: 'bottom',
            alwaysShowAllBtns: true,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
        };
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        let education = "";
        let keySkill = "";
        let jobLocation = "";
        if (this.state.detailsModal) {
            education = (jobDetails.education).join(",   ");
            keySkill = (jobDetails.keySkill).join(",   ");
            jobLocation = $.map(jobDetails.jobLocation, function(obj) {
                return obj.city
            }).join(',  ');
        }

        let viewModelBody =     <div>
                                    <div className="col-md-12">
                                        <label><strong>Job Title :</strong> {jobDetails.title}</label>
                                        <label></label>
                                    </div>
                                    <div className="col-md-12">
                                        <label><strong>Job Summary :</strong>&nbsp;{jobDetails.summary}</label>
                                    </div>
                                    <div className="col-md-12">
                                        <label><strong>Job Description :</strong>&nbsp;{jobDetails.description}</label>
                                    </div>
                                    <div className="col-md-4">
                                        <label><strong>Employment Type :</strong>&nbsp;{jobDetails.employementType}</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label><strong>Experience :</strong>&nbsp;{jobDetails.experienceRequired}</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label><strong>Opening :</strong>&nbsp;{jobDetails.opening}</label>
                                    </div>
                                    <div className="col-md-3">
                                        <label><strong>Salary :</strong>&nbsp;{jobDetails.salary}</label>
                                    </div>
                                    <div className="col-md-12"><label><strong>Key Skill :</strong>&nbsp;{keySkill}</label></div>
                                    <div className="col-md-12"><label><strong>Education :</strong>&nbsp;{education}</label></div>
                                    <div className="col-md-12"><label><strong>Location :</strong> &nbsp;{jobLocation}</label></div>
                                </div>

        let viewModelFooter =  <a type="cancel" className="btn modal-cancel-btn" onClick={this.viewDetails}>Close</a>                 


        return (
            <div className="">
                <div className={"pageForLoading "+className}>
                    <div className=" wrap">
                        <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                        </div>
                    </div>
                </div>
                <div className="history-block">
                    <h3 className="ac-head">Job List</h3>
                    <button className="ac-head" onClick={this.addJobsModal}> Add Job</button>
                    <div className="resume-history">
                        <div className="status-content">
                            <div className="">
                                <BootstrapTable data={list} options={options } remote={true} fetchInfo={ { dataTotalSize: count } } pagination>
                                    <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                                    <TableHeaderColumn width='300' tdAttr={{'data-attr':'Job Title' }} dataField='title'>Job Title</TableHeaderColumn>
                                    <TableHeaderColumn width='150' tdAttr={{'data-attr':'Date' }} dataField='' dataFormat={this.onGetProjectSEDate.bind(this)}>Date</TableHeaderColumn>
                                    {/*<TableHeaderColumn width='150' tdAttr={{'data-attr':'Status' }} dataField='status'>Status</TableHeaderColumn>*/}
                                    <TableHeaderColumn tdAttr={{'data-attr':'Action' }} dataField='' dataFormat={this.jobActionList.bind(this)}>Action</TableHeaderColumn>
                                </BootstrapTable>
                                <div className="form-group">
                                    <ModalComponent title={"View Job"} modalState={this.state.detailsModal} modalBody={viewModelBody} FooterVl={viewModelFooter} action={this.viewDetails} />
                                    <JobEdit categoryOption={categoryOption} cityOption={cityOption} editJob={editJobs} action={this.editDetails} editModal={this.state.editModal} />
                                    <JobAdd categoryOption={categoryOption} isOpen={this.state.addJobModal} cityOption={cityOption} action={this.addJobsModal}/>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    );
                }
            }

function mapStateToProps(state) {
    return {
        responseType: state.Job.type,
        fields: state.home.response.data,
        //resumeCount: state.home.responseCount,
        response: state.Job.response,
    };
}

export default withRouter(connect(mapStateToProps, {
    addjobAction,
    updateJobAction,
    jobListByComAction,
    getAllHome,
    jobEditDataAction,
    jobStatusAction
})(JobList));


// WEBPACK FOOTER //
// ./src/components/Job/JobList.js